<div class="wrapper">
  <div cdkScrollable #contentWrapper class="content-wrapper" (scroll)="scrolled.next($event)">
    <ng-content></ng-content>
  </div>
  <div #scrollbarTrackY class="scrollbar scrollbar-y">
    <div
      #scrollbarThumbY
      cdkDrag
      cdkDragBoundary=".scrollbar-y"
      cdkDragLockAxis="y"
      class="thumb"
      [style.height.px]="
        contentWrapper.offsetHeight > 0
          ? contentWrapper.offsetHeight !== contentWrapper.scrollHeight
            ? (contentWrapper.offsetHeight / contentWrapper.scrollHeight) * scrollbarTrackY.offsetHeight
            : 0
          : 0
      "
    ></div>
  </div>
  <div #scrollbarTrackX class="scrollbar scrollbar-x">
    <div
      #scrollbarThumbX
      cdkDrag
      cdkDragBoundary=".scrollbar-x"
      cdkDragLockAxis="x"
      class="thumb"
      [style.width.px]="
        contentWrapper.offsetWidth > 0
          ? contentWrapper.offsetWidth !== contentWrapper.scrollWidth
            ? (contentWrapper.offsetWidth / contentWrapper.scrollWidth) * scrollbarTrackX.offsetWidth
            : 0
          : 0
      "
    ></div>
  </div>
</div>
